module.exports = __webpack_public_path__ + "static/media/pla_gla_suc.76778234.png";